import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'

import { select } from '@js/util/select'

function mergeDeep(target, source) {
  const isObject = obj => obj && typeof obj === 'object'

  for (const key in source) {
    if (isObject(source[key])) {
      if (!target[key]) Object.assign(target, { [key]: {} })
      mergeDeep(target[key], source[key])
    } else {
      Object.assign(target, { [key]: source[key] })
    }
  }

  return target
}

select('.wpce-swiper', swiperElement => {
  const swiper = new Swiper(
    swiperElement.querySelector('.swiper'),
    mergeDeep(
      {
        modules: [A11y, Navigation],

        // Optional parameters
        direction: 'horizontal',
        slidesPerView: 3,
        spaceBetween: 30,
        speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 300,

        // Don't set threshold to 0 as this can cause scrolling issues in iOS
        threshold: 15,

        navigation: {
          prevEl: swiperElement.querySelector('.swiper-button-prev'),
          nextEl: swiperElement.querySelector('.swiper-button-next'),
        },

        a11y: {
          enabled: true,
        },

        // To enable pagination:
        // - uncomment the following configuration block
        // - import and use the "Pagination" Swiper.js module
        // - uncomment the pagination div in swiper.latte
        // - @use the "swiper/css/pagination" module in swiper.scss
        // - uncomment the pagination styles in swiper.scss
        //
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'bullets',
        //   clickable: true,
        // },

        breakpointsInverse: true,
        breakpoints: {
          320: {
            spaceBetween: 16,
            slidesPerView: 1,
          },
          590: {
            spaceBetween: 24,
            slidesPerView: 2,
          },
          860: {
            spaceBetween: 28,
          },
          1130: {
            spaceBetween: 30,
            slidesPerView: 3,
          },
          1400: {
            spaceBetween: 32,
          },
        },
      },
      swiperElement.dataset.swiperOptions ? JSON.parse(swiperElement.dataset.swiperOptions) : {},
    ),
  )

  swiperElement.classList.toggle('swiper-locked', swiper.isLocked)
  swiper.on('lock', () => {
    swiperElement.classList.add('swiper-locked')
  })
  swiper.on('unlock', () => {
    swiperElement.classList.remove('swiper-locked')
  })

  return () => {
    swiper.destroy()
  }
})
